/*
 * Configuratorul paginii de produs (secțiunea „Pagină produs (radar)”).
 * Desenează pașii (pachet → culoare → câte câmpuri → nume → cadou), arată previzualizarea gravurii,
 * calculează totalul și adaugă în coș prin /cart/add.js, cu numele ca proprietăți ale liniei.
 * Fără dependențe; rulează la fel în temă și în previzualizarea locală (data-lp-preview).
 */
(function () {
  "use strict";

  // Textele implicite (română). Blocul „Texte configurator” le suprascrie și se traduce din Shopify.
  var DEFAULT_TEXTS = {
    stepPack: "Alege pachetul",
    stepColor: "Culoarea",
    stepCount: "Câte {option}?",
    stepNames: "Numele de gravat",
    stepGift: "Ambalaj cadou (opțional)",
    copyColor: "Copiază culoarea de la {item}",
    perPiece: "/ buc.",
    included: "inclus",
    examplePrefix: "ex.",
    invalidChars: "Putem grava doar litere, cifre, spațiu, - și .",
    accentsHint: "Gravăm fără diacritice: ă → a, ș → s, ț → t, î → i.",
    reduceConfirm: "Ai scris deja {total} nume. Dacă alegi {n}, nu le mai gravăm pe: {names}. Continui?",
    errName: "Scrie numele pentru {field}.",
    errConfirm: "Bifează confirmarea numelor.",
    errCart: "Nu am putut adăuga în coș. Încearcă din nou.",
    total: "Total",
    totalPack: "Total pachet",
    etaPrefix: "Estimat:",
    etaRange: "",
    defaultColor: "Auriu",
    bundleDiscounts: "",
  };

  // Litera fără semne diacritice (ă → a, è → e), sau null dacă nu e o literă latină cu diacritice.
  function baseLetter(ch) {
    var base = ch.normalize("NFD").replace(/[̀-ͯ]/g, "");
    return base !== ch && /^[A-Za-z]$/.test(base) ? base : null;
  }

  function fill(text, vars) {
    return String(text).replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; });
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === "text") node.textContent = attrs[k];
      else if (k === "html") node.innerHTML = attrs[k];
      else if (k.indexOf("on") === 0) node.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== false && attrs[k] != null) node.setAttribute(k, attrs[k] === true ? "" : attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(typeof c === "string" ? document.createTextNode(c) : c); });
    return node;
  }

  function storage() {
    try { return window.sessionStorage; } catch { return null; }
  }

  function init(root) {
    var data = JSON.parse(root.querySelector("[data-lp-data]").textContent);
    var product = data.product;
    var cfg = data.settings;
    var t = {};
    Object.keys(DEFAULT_TEXTS).forEach(function (k) { t[k] = data.texts && data.texts[k] != null && data.texts[k] !== "" ? data.texts[k] : DEFAULT_TEXTS[k]; });
    var locale = data.locale || "ro";
    var currency = data.currency || data.shopCurrency || "RON";
    var gift = data.gift;
    var preview = root.hasAttribute("data-lp-preview");
    var options = product.options.map(function (o) { return typeof o === "string" ? o : o.name; });
    var colorIdx = options.indexOf(cfg.colorOption);
    var countIdx = options.indexOf(cfg.countOption);
    var maxChars = Number(cfg.maxChars) || 10;
    var placeholders = String(cfg.fieldPlaceholders || "").split(",").map(function (x) { return x.trim(); }).filter(Boolean);

    var colors = uniq(product.variants.map(function (v) { return colorIdx >= 0 ? v.options[colorIdx] : null; }).filter(Boolean));
    var counts = uniq(product.variants.map(function (v) { return countIdx >= 0 ? v.options[countIdx] : null; }).filter(Boolean))
      .sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    var swatches = parseSwatches(cfg.swatches);

    var key = "lp-" + product.id;
    var saved = null;
    try { saved = JSON.parse((storage() && storage().getItem(key)) || "null"); } catch { saved = null; }
    var state = saved && saved.v === 1 ? saved : {
      v: 1,
      pack: 1,
      active: 0,
      bracelets: [newBracelet(), newBracelet()],
      gift: false,
      giftMessage: "",
    };

    function newBracelet() {
      return { color: colors.indexOf(t.defaultColor) >= 0 ? t.defaultColor : colors[0] || null, count: counts[0] || null, names: [] };
    }

    // Starea salvată poate veni din altă limbă (culorile au alte nume): păstrăm doar ce există în limba de acum.
    state.bracelets.forEach(function (b) {
      if (colors.indexOf(b.color) < 0) b.color = newBracelet().color;
      if (counts.indexOf(b.count) < 0) b.count = counts[0] || null;
    });

    var $ = function (sel) { return root.querySelector(sel); };
    var configEl = $("[data-lp-config]");
    var summaryEl = $("[data-lp-summary]");
    var confirmEl = $("[data-lp-confirm]");
    var errorEl = $("[data-lp-error]");
    var ctaEl = $("[data-lp-cta]");
    var totalEl = $("[data-lp-total]");
    var priceEl = $("[data-lp-price]");
    var form = root.querySelector("form");

    // ------------------------------------------------------------------ prețuri

    // Lei ca pe restul paginii („195 lei”); celelalte monede în formatul limbii vizitatorului („44,90 €”).
    function fmt(cents) {
      var n = cents / 100;
      var whole = Math.round(n * 100) % 100 === 0;
      if (currency === "RON") {
        return new Intl.NumberFormat("ro-RO", { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(n) + " " + (cfg.currencySuffix || "lei");
      }
      return new Intl.NumberFormat(locale, { style: "currency", currency: currency }).format(n);
    }

    // Reducerea pachetului în moneda vizitatorului, ca reducerea automată din Shopify:
    // „EUR:22.25%” (procent din cele două produse) sau „PLN:79” (sumă fixă); în moneda magazinului, setarea secțiunii.
    var bundleRule = (function () {
      var map = {};
      String(t.bundleDiscounts).split(",").forEach(function (pair) {
        var m = pair.trim().match(/^([A-Za-z]{3})\s*[:=]\s*([\d.,]+)\s*(%?)$/);
        if (m) map[m[1].toUpperCase()] = { value: parseFloat(m[2].replace(",", ".")), percent: m[3] === "%" };
      });
      if (map[currency]) return map[currency];
      return { value: currency === (data.shopCurrency || "RON") ? (Number(cfg.bundleDiscount) || 0) / 100 : 0, percent: false };
    })();

    function bundleDiscount(subtotal) {
      return bundleRule.percent ? Math.round((subtotal * bundleRule.value) / 100) : Math.round(bundleRule.value * 100);
    }

    function variantFor(b) {
      return product.variants.find(function (v) {
        return (colorIdx < 0 || v.options[colorIdx] === b.color) && (countIdx < 0 || v.options[countIdx] === b.count);
      }) || product.variants[0];
    }

    function itemName(i) {
      return (cfg.itemLabel || "Produsul") + " " + (i + 1);
    }

    function countLabel(n) {
      return n + " " + (n === 1 && cfg.countSingular ? cfg.countSingular : (cfg.countOption || "").toLowerCase());
    }

    // Exemplele de nume, transformate ca textul gravat (fără diacritice, dacă furnizorul nu le gravează).
    function example(i) {
      return cleanName(placeholders[i % Math.max(placeholders.length, 1)] || "").value;
    }

    function fieldCount(b) {
      return countIdx >= 0 ? parseInt(b.count, 10) || 1 : 1;
    }

    function total() {
      var sum = 0;
      for (var i = 0; i < state.pack; i++) sum += variantFor(state.bracelets[i]).price;
      if (state.pack === 2 && cfg.bundleEnabled) sum -= bundleDiscount(sum);
      if (gift && state.gift) sum += gift.price;
      return sum;
    }

    function deltaFor(b, count) {
      var base = variantFor({ color: b.color, count: counts[0] }).price;
      return variantFor({ color: b.color, count: count }).price - base;
    }

    // ------------------------------------------------------------------ nume

    function cleanName(raw) {
      var converted = false;
      var removed = false;
      var out = "";
      for (var i = 0; i < raw.length; i++) {
        var ch = raw[i];
        var base = baseLetter(ch);
        if (base && !cfg.allowDiacritics) { out += base; converted = true; continue; }
        if (/[A-Za-z0-9 .'\-]/.test(ch) || (cfg.allowDiacritics && base)) out += ch;
        else removed = true;
      }
      out = out.replace(/\s{2,}/g, " ").slice(0, maxChars);
      return { value: out, converted: converted, removed: removed };
    }

    // ------------------------------------------------------------------ desen

    function stepTitle(n, text) {
      return el("p", { class: "lp-step__title" }, [el("span", { class: "lp-step__n", text: String(n) }), text]);
    }

    function render() {
      configEl.innerHTML = "";
      var n = 1;

      if (cfg.bundleEnabled) {
        var packs = [1, 2].map(function (k) {
          var label = k === 1 ? cfg.bundleSingleLabel : cfg.bundlePackLabel;
          var price = k === 1
            ? variantFor({ color: state.bracelets[0].color, count: counts[0] }).price
            : (function (pair) { return pair - bundleDiscount(pair); })(2 * variantFor({ color: state.bracelets[0].color, count: counts[0] }).price);
          var per = k === 2 ? el("small", { text: fmt(price / 2) + " " + t.perPiece }) : null;
          return el("button", {
            type: "button",
            class: "lp-pack-opt",
            "aria-pressed": String(state.pack === k),
            onclick: function () { state.pack = k; state.active = 0; update(true); },
          }, [el("strong", { text: label }), el("span", { text: fmt(price) }), per]);
        });
        configEl.appendChild(el("div", { class: "lp-step" }, [stepTitle(n++, t.stepPack), el("div", { class: "lp-pack-opts" }, packs)]));
      }

      if (state.pack === 2) {
        var tabs = [0, 1].map(function (i) {
          var done = isComplete(state.bracelets[i]);
          return el("button", {
            type: "button",
            class: "lp-tab",
            role: "tab",
            "aria-selected": String(state.active === i),
            onclick: function () { state.active = i; update(true); },
          }, [itemName(i), done ? el("span", { class: "lp-tab__ok", text: " ✓" }) : null]);
        });
        configEl.appendChild(el("div", { class: "lp-tabs", role: "tablist" }, tabs));
      }

      var b = state.bracelets[state.active];

      if (colorIdx >= 0) {
        var sw = colors.map(function (c) {
          return el("button", {
            type: "button",
            class: "lp-swatch",
            "aria-pressed": String(b.color === c),
            onclick: function () { b.color = c; showColorImage(c); update(true); },
          }, [el("span", { class: "lp-swatch__dot", style: "background:" + (swatches[c] || "#ccc") }), el("span", { text: c })]);
        });
        var copy = state.pack === 2 && state.active === 1
          ? el("button", { type: "button", class: "lp-link", text: fill(t.copyColor, { item: itemName(0) }), onclick: function () { b.color = state.bracelets[0].color; update(true); } })
          : null;
        configEl.appendChild(el("div", { class: "lp-step" }, [stepTitle(n++, t.stepColor), el("div", { class: "lp-swatches" }, sw), copy]));
      }

      if (countIdx >= 0) {
        var pills = counts.map(function (c) {
          var d = deltaFor(b, c);
          return el("button", {
            type: "button",
            class: "lp-pill",
            "aria-pressed": String(b.count === c),
            onclick: function () { setCount(b, c); },
          }, [el("strong", { text: String(parseInt(c, 10) || c) }), el("small", { text: d > 0 ? "+" + fmt(d) : t.included })]);
        });
        configEl.appendChild(el("div", { class: "lp-step" }, [stepTitle(n++, fill(t.stepCount, { option: (cfg.countOption || "").toLowerCase() })), el("div", { class: "lp-pills" }, pills)]));
      }

      var fields = [];
      for (var i = 0; i < fieldCount(b); i++) fields.push(nameField(b, i));
      var hint = el("p", { class: "lp-hint", "data-lp-hint": "" });
      configEl.appendChild(el("div", { class: "lp-step", "data-lp-names": "" }, [
        stepTitle(n++, t.stepNames),
        el("div", { class: "lp-fields" }, fields),
        hint,
        el("div", { class: "lp-preview", "aria-hidden": "true" }, [svgPreview(b)]),
        el("p", { class: "lp-preview__note", text: cfg.previewNote }),
      ]));

      if (gift) {
        var giftBox = el("label", { class: "lp-check" }, [
          el("input", { type: "checkbox", checked: state.gift, onchange: function (e) { state.gift = e.target.checked; update(true); } }),
          el("span", { text: cfg.giftLabel + " · +" + fmt(gift.price) }),
        ]);
        var msg = state.gift
          ? el("label", { class: "lp-field" }, [
              el("span", { class: "lp-field__label", text: cfg.giftMessageLabel }),
              el("textarea", { maxlength: "150", rows: "3", oninput: function (e) { state.giftMessage = e.target.value; save(); } }, [state.giftMessage]),
            ])
          : null;
        configEl.appendChild(el("div", { class: "lp-step" }, [stepTitle(n++, t.stepGift), giftBox, msg]));
      }
    }

    function nameField(b, i) {
      var id = "lp-name-" + product.id + "-" + state.active + "-" + i;
      var counter = el("span", { class: "lp-field__count", text: (b.names[i] || "").length + "/" + maxChars });
      var input = el("input", {
        id: id,
        type: "text",
        value: b.names[i] || "",
        maxlength: String(maxChars + 4),
        placeholder: t.examplePrefix + " " + example(i),
        autocomplete: "off",
        autocapitalize: "words",
        spellcheck: "false",
        "data-lp-name": String(i),
        oninput: function (e) {
          var r = cleanName(e.target.value);
          if (r.value !== e.target.value) e.target.value = r.value;
          b.names[i] = r.value;
          counter.textContent = r.value.length + "/" + maxChars;
          counter.classList.toggle("is-near", r.value.length >= maxChars - 1);
          var hint = root.querySelector("[data-lp-hint]");
          if (hint) hint.textContent = r.removed ? t.invalidChars : r.converted ? t.accentsHint : "";
          refreshPreview();
          update(false);
        },
      });
      return el("label", { class: "lp-field", for: id }, [
        el("span", { class: "lp-field__label", text: cfg.fieldLabel + " " + (i + 1) }),
        input,
        counter,
      ]);
    }

    function setCount(b, c) {
      var newN = parseInt(c, 10) || 1;
      var filled = b.names.slice(newN).filter(function (x) { return x && x.trim(); });
      if (filled.length && !window.confirm(fill(t.reduceConfirm, { total: newN + filled.length, n: newN, names: filled.join(", ") }))) return;
      b.count = c;
      update(true);
    }

    // Previzualizare: lanț cu N lăbuțe în culoarea aleasă, cu numele pe fiecare.
    function svgPreview(b) {
      var NS = "http://www.w3.org/2000/svg";
      var nCharms = fieldCount(b);
      var perRow = nCharms > 4 ? Math.ceil(nCharms / 2) : nCharms;
      var rows = Math.ceil(nCharms / perRow);
      var cw = 74;
      var w = Math.max(perRow * cw + 40, 220);
      var h = rows * 86 + 10;
      var hex = swatches[b.color] || "#d4af37";
      var svg = document.createElementNS(NS, "svg");
      svg.setAttribute("viewBox", "0 0 " + w + " " + h);
      svg.setAttribute("class", "lp-preview__svg");
      var gid = "lpg" + product.id + state.active;
      svg.innerHTML =
        '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="1" y2="1">' +
        '<stop offset="0" stop-color="' + mix(hex, "#ffffff", 0.55) + '"/>' +
        '<stop offset="0.55" stop-color="' + hex + '"/>' +
        '<stop offset="1" stop-color="' + mix(hex, "#000000", 0.25) + '"/></linearGradient></defs>';
      for (var r = 0; r < rows; r++) {
        var y = 10 + r * 86 + 44;
        var inRow = Math.min(perRow, nCharms - r * perRow);
        var x0 = (w - inRow * cw) / 2;
        svg.innerHTML += '<path d="M6 ' + y + ' H' + (w - 6) + '" stroke="' + mix(hex, "#000000", 0.15) + '" stroke-width="1.6" stroke-dasharray="5 3" fill="none"/>';
        for (var k = 0; k < inRow; k++) {
          var idx = r * perRow + k;
          var cx = x0 + k * cw + cw / 2;
          var name = (b.names[idx] || "").trim() || example(idx);
          var empty = !(b.names[idx] || "").trim();
          var size = Math.min(11, 150 / Math.max(name.length, 1) / 1.6);
          svg.innerHTML +=
            '<g transform="translate(' + (cx - 30) + ' ' + (y - 40) + ')">' +
            '<ellipse cx="13" cy="19" rx="6" ry="8" transform="rotate(-25 13 19)" fill="url(#' + gid + ')"/>' +
            '<ellipse cx="24" cy="10" rx="6" ry="8" fill="url(#' + gid + ')"/>' +
            '<ellipse cx="37" cy="10" rx="6" ry="8" fill="url(#' + gid + ')"/>' +
            '<ellipse cx="48" cy="19" rx="6" ry="8" transform="rotate(25 48 19)" fill="url(#' + gid + ')"/>' +
            '<path d="M30 25 C45 25 54 36 52 47 C50 57 40 58 30 55 C20 58 10 57 8 47 C6 36 15 25 30 25 Z" fill="url(#' + gid + ')" stroke="' + mix(hex, "#000000", 0.2) + '" stroke-width="0.6"/>' +
            '<text x="30" y="44" text-anchor="middle" font-family="Georgia, serif" font-size="' + size.toFixed(1) + '" fill="' + (empty ? "rgba(0,0,0,0.25)" : "rgba(40,30,20,0.78)") + '">' + escapeXml(name) + "</text>" +
            "</g>";
        }
      }
      return svg;
    }

    function refreshPreview() {
      var box = root.querySelector(".lp-preview");
      if (!box) return;
      box.innerHTML = "";
      box.appendChild(svgPreview(state.bracelets[state.active]));
    }

    // ------------------------------------------------------------------ rezumat, total, validare

    function isComplete(b) {
      for (var i = 0; i < fieldCount(b); i++) if (!(b.names[i] || "").trim()) return false;
      return true;
    }

    function summaryText() {
      var lines = [];
      for (var i = 0; i < state.pack; i++) {
        var b = state.bracelets[i];
        var names = b.names.slice(0, fieldCount(b)).map(function (x) { return (x || "").trim() || "…"; }).join(" / ");
        lines.push((state.pack === 2 ? itemName(i) + ": " : "") +
          [b.color, countIdx >= 0 ? countLabel(fieldCount(b)) : null, names].filter(Boolean).join(" · "));
      }
      if (gift && state.gift) lines.push(cfg.giftLabel + " ✓");
      return lines;
    }

    function update(rerender) {
      if (rerender) render();
      var amount = fmt(total());
      totalEl.textContent = amount;
      priceEl.textContent = amount;
      var sticky = root.querySelector("[data-lp-sticky-total]");
      if (sticky) sticky.textContent = amount;
      summaryEl.hidden = false;
      summaryEl.innerHTML = "";
      summaryText().forEach(function (line) { summaryEl.appendChild(el("p", { text: line })); });
      summaryEl.appendChild(el("p", { class: "lp-summary__total" }, [el("span", { text: state.pack === 2 ? t.totalPack : t.total }), el("strong", { text: amount })]));
      var ready = complete();
      var stickyBtn = root.querySelector("[data-lp-sticky-btn]");
      if (stickyBtn) stickyBtn.textContent = ready ? cfg.addText : cfg.personalizeText;
      save();
    }

    function complete() {
      for (var i = 0; i < state.pack; i++) if (!isComplete(state.bracelets[i])) return false;
      return confirmEl.checked;
    }

    function firstError() {
      for (var i = 0; i < state.pack; i++) {
        var b = state.bracelets[i];
        for (var k = 0; k < fieldCount(b); k++) {
          if (!(b.names[k] || "").trim()) return { bracelet: i, field: k, text: fill(t.errName, { field: cfg.fieldLabel + " " + (k + 1) + (state.pack === 2 ? " (" + itemName(i) + ")" : "") }) };
        }
      }
      if (!confirmEl.checked) return { confirm: true, text: t.errConfirm };
      return null;
    }

    function showError(err) {
      errorEl.hidden = false;
      errorEl.textContent = err.text;
      if (err.confirm) { confirmEl.focus(); confirmEl.scrollIntoView({ behavior: "smooth", block: "center" }); return; }
      if (state.active !== err.bracelet) { state.active = err.bracelet; update(true); }
      var input = root.querySelector('[data-lp-name="' + err.field + '"]');
      if (input) { input.focus(); input.scrollIntoView({ behavior: "smooth", block: "center" }); }
    }

    function lineItems() {
      var items = [];
      for (var i = 0; i < state.pack; i++) {
        var b = state.bracelets[i];
        var props = {};
        for (var k = 0; k < fieldCount(b); k++) props[cfg.fieldLabel + " " + (k + 1)] = b.names[k].trim();
        props["_Confirmare nume"] = "da";
        if (!cfg.allowDiacritics) props["_Fără diacritice"] = "da";
        if (state.pack === 2) props["_Pachet"] = "2 buc.";
        items.push({ id: variantFor(b).id, quantity: 1, properties: props });
      }
      if (gift && state.gift) items.push({ id: gift.variantId, quantity: 1, properties: state.giftMessage.trim() ? { "Mesaj card": state.giftMessage.trim() } : {} });
      return items;
    }

    function submit(e) {
      if (e) e.preventDefault();
      var err = firstError();
      if (err) { showError(err); return; }
      errorEl.hidden = true;
      var payload = { items: lineItems() };
      if (preview) {
        window.alert("Previzualizare: în magazin s-ar adăuga în coș\n\n" + JSON.stringify(payload, null, 2));
        return;
      }
      ctaEl.disabled = true;
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      fetch(rootUrl + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(payload) })
        .then(function (res) { if (!res.ok) throw new Error(String(res.status)); return res.json(); })
        .then(function () { window.location.href = rootUrl + (cfg.afterAdd === "checkout" ? "checkout" : "cart"); })
        .catch(function () {
          ctaEl.disabled = false;
          errorEl.hidden = false;
          errorEl.textContent = t.errCart;
        });
    }

    function save() {
      var st = storage();
      try { if (st) st.setItem(key, JSON.stringify(state)); } catch { /* stocare indisponibilă */ }
    }

    // ------------------------------------------------------------------ galerie, livrare, bară de jos

    function showColorImage(color) {
      var v = variantFor({ color: color, count: state.bracelets[state.active].count });
      var mediaId = v && v.featured_media && v.featured_media.id;
      if (!mediaId) return;
      var slide = root.querySelector('[data-media-id="' + mediaId + '"]');
      var track = root.querySelector("[data-lp-track]");
      if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: "smooth" });
    }

    function gallery() {
      var track = root.querySelector("[data-lp-track]");
      var dots = root.querySelector("[data-lp-dots]");
      if (!track || !dots) return;
      var slides = track.children;
      for (var i = 0; i < slides.length; i++) dots.appendChild(el("span", { class: i === 0 ? "is-on" : "" }));
      track.addEventListener("scroll", function () {
        var idx = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        for (var k = 0; k < dots.children.length; k++) dots.children[k].classList.toggle("is-on", k === idx);
      }, { passive: true });
    }

    function eta() {
      var box = root.querySelector("[data-lp-eta]");
      if (!box) return;
      var opts = { weekday: "short", day: "numeric", month: "short" };
      // Intervalul din texte (traductibil, ex. „10-18” pentru altă țară) are prioritate față de numerele secțiunii.
      var range = String(t.etaRange).match(/(\d+)\s*[-–]\s*(\d+)/);
      var a = new Date(); a.setDate(a.getDate() + (range ? Number(range[1]) : Number(cfg.etaMin) || 7));
      var b = new Date(); b.setDate(b.getDate() + (range ? Number(range[2]) : Number(cfg.etaMax) || 14));
      box.textContent = t.etaPrefix + " " + a.toLocaleDateString(locale, opts) + " – " + b.toLocaleDateString(locale, opts);
    }

    function sticky() {
      var bar = root.querySelector("[data-lp-sticky]");
      var top = root.querySelector(".lp-top");
      if (!bar || !top || !("IntersectionObserver" in window)) return;
      new IntersectionObserver(function (entries) {
        bar.hidden = entries[0].isIntersecting;
      }).observe(top);
      root.querySelector("[data-lp-sticky-btn]").addEventListener("click", function () {
        if (complete()) submit();
        else { var err = firstError(); if (err) showError(err); else configEl.scrollIntoView({ behavior: "smooth" }); }
      });
    }

    // ------------------------------------------------------------------ pornire

    confirmEl.addEventListener("change", function () { update(false); });
    form.addEventListener("submit", submit);
    // Butoanele din secțiunea de informații (altă secțiune) ajung aici prin clicul ascultat pe document (boot).
    root.lpApi = {
      selectPack: function () { state.pack = 2; state.active = 0; update(true); configEl.scrollIntoView({ behavior: "smooth", block: "start" }); },
      scrollConfig: function () { configEl.scrollIntoView({ behavior: "smooth", block: "start" }); },
    };

    gallery();
    eta();
    sticky();
    update(true);
  }

  // ------------------------------------------------------------------ utilitare

  function uniq(list) {
    return list.filter(function (x, i) { return list.indexOf(x) === i; });
  }

  function parseSwatches(text) {
    var out = {};
    String(text || "").split(",").forEach(function (pair) {
      var m = pair.split(":");
      if (m.length === 2) out[m[0].trim()] = m[1].trim();
    });
    return out;
  }

  function mix(hex, withHex, amount) {
    var a = toRgb(hex);
    var b = toRgb(withHex);
    var c = a.map(function (v, i) { return Math.round(v + (b[i] - v) * amount); });
    return "rgb(" + c.join(",") + ")";
  }

  function toRgb(hex) {
    var h = hex.replace("#", "");
    if (h.length === 3) h = h.split("").map(function (x) { return x + x; }).join("");
    return [0, 2, 4].map(function (i) { return parseInt(h.slice(i, i + 2), 16) || 0; });
  }

  function escapeXml(s) {
    return String(s).replace(/[<>&"']/g, function (c) { return { "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;", "'": "&#39;" }[c]; });
  }

  // „Alege pachetul de 2” și „Personalizează” pot fi în altă secțiune decât configuratorul.
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-lp-pack-link], [data-lp-pack-select], [data-lp-scroll-config]");
    var root = btn && document.querySelector("[data-lp-root]");
    if (!root || !root.lpApi) return;
    if (btn.hasAttribute("data-lp-scroll-config")) root.lpApi.scrollConfig();
    else root.lpApi.selectPack();
  });

  function boot() {
    document.querySelectorAll("[data-lp-root]").forEach(function (root) {
      if (root.dataset.lpReady) return;
      root.dataset.lpReady = "1";
      init(root);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  // În editorul temei, secțiunea se reîncarcă la fiecare modificare.
  document.addEventListener("shopify:section:load", boot);
})();
